export default __webpack_public_path__ + "static/media/play-button.95b554a2.png";